import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import TeacherCombo from '../combos/TeacherCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';



export default function SchoolAutoTiming(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [schoolClass, setSchoolClass] = useState(null);
    const [teacher, setTeacher] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState("");

    

    useEffect(() => {
    }, []);
    const checkDataEntry = function(){
      if(teacher == null){
        setErorVisible(true);
        setErrorMessage("معلم را انتخاب نمائید");
        return false;
      }
      if(schoolClass == null){
        setErorVisible(true);
        setErrorMessage("کلاس را انتخاب نمائید");
        return false;
      }
      return true;
    }

    const saveItem = function(){
      if(!checkDataEntry()) return;
      var params = {
        login:util.getTrustedUser(), 
        schoolClassId:schoolClass.id,
        teacherId:teacher.id,
      };
      setSaving(true);
      var url = config.Server+`/school/timing/auto/create`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });              
                setSaving(false);
                setTeacher(null);
                setSchoolClass(null);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    return(      
      (redirectUrl != "")
          ?
          <Navigate to={redirectUrl} replace={false}  />
      :
      <>
         <ShowVideo videoId="school_timing" top={65} md={6} />
          <div className="card" style={{width:"100%", maxWidth:"525px", borderBlockColor:"#414141",marginTop:"20px" }}>
            
          <table style={{width:"100%", borderCollapse:"collapse"}}>
            <tbody>
              <tr><td colSpan={4} style={{padding:"10px"}}>
                <label onClick={()=>setRedirectUrl("/school/timing")} style={{cursor:"pointer", color:"#3e9aff"}}>
                <img src={require('../lib/images/back.png')} width={24} />
                برگشت به برنامه هفتگی
                </label>
                
                </td></tr>
              <tr><td colSpan={4} style={{backgroundColor:"royalblue", color:"#FFFFFF",padding:"5px", borderRadius:"5px", fontSize:"14pt"}}>ثبت خودکار برنامه ابتدائی</td></tr>
              <tr><td colSpan={4}>&nbsp;</td></tr>
              <tr>
                <td colSpan={4} style={{padding:"10px"}}>
                    <TeacherCombo returnFullItem={true} value={teacher} onChange={(val) => setTeacher(val)}/>                  
                </td>
              </tr>
              <tr>
                <td colSpan={4} style={{padding:"10px"}}>
                    <SchoolClassCombo returnFullItem={true} value={schoolClass} onChange={(val) => setSchoolClass(val)} />
                </td>
              </tr>
              <tr><td colSpan={4}><hr/></td></tr>
              <tr><td colSpan={4}>
                توجه!
                <br/>
                در صورت ثبت، تمام برنامه ریزی مربوط به معلم و کلاس فوق حذف شده و با برنامه خودکار جایگزین می شوند  
              </td></tr>
              <tr><td colSpan={4}><hr/></td></tr>
              <tr>
                <td colSpan={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label="ثبت شود" icon="pi pi-check" onClick={()=>saveItem(true)} severity="success" iconPos="right" loading={saving} />
                    
                  </div>
                </td>
                <td colSpan={2}>
                </td>
              </tr>
              <tr><td colSpan={4}>&nbsp;</td></tr>

            </tbody>
          </table>            
          </div>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
